import $ from 'jquery';

class SitecoreGoals {
	addGoalTrigger(el) {
		var url = $(el).data('api-url');
		var goalId = $(el).data('goal-id');
		if (url !== '' && goalId !== '') {
			el.addEventListener('click', () => this.submitRequest(url, goalId));
		}
	}

	submitRequest(url, goalId) {
		var parameter = '?goal=' + goalId;
		var postUrl = window.location.origin + '/' + url + parameter;
		$.ajax({
			type: 'POST',
			url: postUrl
		});
	}
}

export default new SitecoreGoals();
